The organization that is contributing to the workflow process.
